/**
 * Extrai o multiplicador de pack do nome do produto
 * Exemplo: "Pack x 6 Veludo de Vaca~130g" retorna 6
 * Exemplo: "Veludo de Vaca~130g" retorna 1 (não é pack)
 *
 * @param {string} productName - Nome do produto
 * @returns {number} - Multiplicador (padrão: 1 se não for pack)
 */
export function extractPackMultiplier(productName) {
  if (!productName || typeof productName !== 'string') {
    return 1;
  }

  // Regex para encontrar padrão "x N" ou "X N" no nome do produto
  // Exemplos: "Pack x 6", "pack X 12", "PACK x 3"
  const match = productName.match(/\bpack\s*x\s*(\d+)\b/i);

  if (match && match[1]) {
    const multiplier = parseInt(match[1], 10);
    return multiplier > 0 ? multiplier : 1;
  }

  return 1; // Não é pack, multiplicador = 1
}

/**
 * Peso por unidade individual de um produto.
 * Usa cured_weight_kg apenas quando o produto está marcado como curado E
 * esse peso está realmente definido (> 0); caso contrário cai sempre para
 * initial_weight_kg — o cálculo normal por unidade, igual para todos os
 * produtos. Evita que um cured_weight_kg em falta/zero (dado incompleto)
 * zere o peso calculado em vez de usar o peso normal do produto.
 *
 * @param {{is_cured?: boolean, cured_weight_kg?: number, initial_weight_kg?: number}} product
 * @returns {number}
 */
export function getUnitWeight(product) {
  if (!product) return 0;
  if (product.is_cured && product.cured_weight_kg > 0) {
    return product.cured_weight_kg;
  }
  return product.initial_weight_kg || 0;
}
